import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function AdminPedidosRedirect() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { userId, nivelAcesso } = useAuth();

  useEffect(() => {
    // Se não está logado, vai para login
    if (!userId) {
      navigate('/login', { replace: true });
      return;
    }

    // Perfis que podem acessar visualizar pedido (admin, entregador, separador, etc)
    const perfisAdministrativos = ['Administrador', 'Entregador', 'Separador', 'AssistenteAtendimento'];
    
    if (!perfisAdministrativos.includes(nivelAcesso)) {
      // Se não é admin/entregador, tenta ir para seus pedidos
      navigate(`/menu/perfil/meuspedidos/${id}`, { replace: true });
      return;
    }

    // Se é admin/entregador, redireciona para visualizar pedido
    navigate(`/menu/pedidos`, { state: { id }, replace: true });
  }, [userId, nivelAcesso, id, navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h2>Carregando pedido...</h2>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #131C46',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '20px auto'
        }} />
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
